import type { INavItem } from '@anywayseo/tools';

export const legalRoutes: INavItem[] = [
  { label: 'Datenschutzrichtlinie', path: '/datenschutzrichtlinie' },
  { label: 'Cookie-Richtlinie', path: '/cookie-richtlinie' },
  { label: 'Allgemeine Geschäftsbedingungen', path: '/allgemeine-geschaeftsbedingungen' },
  { label: 'Kontakt ', path: '/kontakt' },
];
